import React from 'react';
import { cn } from '../../lib/utils';

/**
 * Varianti del badge
 */
const badgeVariants = {
  variant: {
    default: 'border-transparent bg-primary text-primary-foreground shadow hover:bg-primary/80',
    secondary: 'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80',
    destructive: 'border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80',
    outline: 'text-foreground',
    success: 'border-transparent bg-green-500 text-white shadow hover:bg-green-600',
    warning: 'border-transparent bg-yellow-500 text-white shadow hover:bg-yellow-600',
    info: 'border-transparent bg-blue-500 text-white shadow hover:bg-blue-600'
  }
};

/**
 * Badge component
 */
const Badge = React.forwardRef(({ className, variant = 'default', ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(
        'inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors',
        'focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
        badgeVariants.variant[variant],
        className
      )}
      {...props}
    />
  );
});

Badge.displayName = 'Badge';

export { Badge, badgeVariants };
